// Module
var code = `<table class="table">
  <tbody>
  <tr ng-repeat="(parameterName, parameterValue) in \$ctrl.printParameters" ng-if="\$ctrl.printHasParams()">
    <td>{{\$ctrl.translatePrintParam(parameterName)}}</td>
    <td>
      <select
        disabled
        class="form-control"
        ng-model="\$ctrl.print.parameters[parameterName]"
        ng-change="\$ctrl.onChange()"
        ng-options="type.id as type.label for type in \$ctrl.printParameters[parameterName]">
      </select>
    </td>
  </tr>
  <tr>
    <td>Is print active</td>
    <td>
      <select
        required
        ng-model="\$ctrl.print.active"
        boolean-options>
      </select>
    </td>
  </tr>
  <tr>
    <td>Is reprint available</td>
    <td>
      <select
        required
        ng-model="\$ctrl.print.canReprint"
        boolean-options>
      </select>
    </td>
  </tr>
  <tr>
    <td>Type</td>
    <td>
      <select
        required
        ng-model="\$ctrl.print.type"
        ng-options="o.value as o.label for o in \$ctrl.printTypes"
        ng-change="\$ctrl.onChange()"
      >
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.print.type === 'TEMPLATE'">
    <td>Editor type</td>
    <td>
      <select
        ng-model="\$ctrl.print.templateEditorType"
        ng-options="o.value as o.label for o in \$ctrl.templateEditorTypes"
        ng-change="\$ctrl.onChange()"
      >
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.print.type === 'COORDINATE'">
    <td>Print background</td>
    <td>
      <file-id-upload ng-model="\$ctrl.print.backgroundFileIds"
                   show-remarks="false"
                   ng-change="\$ctrl.onChange()"
                   show-file-name="false"
                   validate="{pattern: '.jpg,*.jpeg', size: { max: '1MB'}}"
                   name="documentUpload"
      >
      </file-id-upload>
    </td>
  </tr>
  <tr ng-if="\$ctrl.print.type === 'COORDINATE'">
    <td>Orientation</td>
    <td>
      <select
        required
        ng-model="\$ctrl.print.orientation"
        ng-change="\$ctrl.onChange()"
        ng-options="o.value as o.label for o in [{ label: 'Landscape', value: 'LANDSCAPE' }, { label: 'Portrait', value: 'PORTRAIT' }]">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.print.type === 'COORDINATE'">
    <td>Short Edge</td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               ng-model="\$ctrl.print.shortEdge"
               ng-change="\$ctrl.onInputChange()"
               ng-max="\$ctrl.print.longEdge"
               min="0"/>
      </glue-container>
    </td>
  </tr>
  <tr ng-if="\$ctrl.print.type === 'COORDINATE'">
    <td>Long Edge</td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               ng-model="\$ctrl.print.longEdge"
               ng-change="\$ctrl.onInputChange()"
               ng-min="\$ctrl.print.shortEdge"
               min="0"/>
      </glue-container>
    </td>
  </tr>
  <tr ng-if="\$ctrl.getAttr('MULTILINE_Y_SPACING') !== undefined && \$ctrl.print.type === 'COORDINATE'">
    <td>Y-spacing - space between lines</td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               string-to-int
               ng-model="\$ctrl.getAttr('MULTILINE_Y_SPACING').value"
               ng-change="\$ctrl.onChange()"
               ng-step="1"
               min="0"/>
      </glue-container>
    </td>
  </tr>
  <tr ng-if="\$ctrl.getAttr('MULTILINE_LINE_COUNT') !== undefined && \$ctrl.print.type === 'COORDINATE'">
    <td>Lines number per page</td>
    <td>
      <input class="print-details__control-input"
             type="number"
             string-to-int
             ng-model="\$ctrl.getAttr('MULTILINE_LINE_COUNT').value"
             ng-change="\$ctrl.onChange()"
             ng-step="1"
             min="0"/>
    </td>
  </tr>
  <tr ng-if="\$ctrl.getAttr('PAGE_SHEET_BREAK_ENABLE') && \$ctrl.print.type === 'COORDINATE'">
    <td>Use page sheet break spacing</td>
    <td>
      <select boolean-options
              string-to-boolean
              ng-model="\$ctrl.getAttr('PAGE_SHEET_BREAK_ENABLE').value"
              ng-change="\$ctrl.onPageSheetBreakChange() && \$ctrl.onChange()">
      </select>
    </td>
  </tr>
  <tr ng-if="\$ctrl.getAttrBoolValue('PAGE_SHEET_BREAK_ENABLE') && \$ctrl.getAttr('PAGE_SHEET_BREAK_HEIGHT') && \$ctrl.print.type === 'COORDINATE'">
    <td>Page sheet break height</td>
    <td>
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               string-to-int
               ng-model="\$ctrl.getAttr('PAGE_SHEET_BREAK_HEIGHT').value"
               ng-change="\$ctrl.onChange()"
               ng-step="1"
               min="1"
               ng-required="\$ctrl.getAttrBoolValue('PAGE_SHEET_BREAK_ENABLE')"/>
      </glue-container>
    </td>
  </tr>
  <tr ng-if="\$ctrl.getAttrBoolValue('PAGE_SHEET_BREAK_ENABLE') && \$ctrl.getAttr('PAGE_SHEET_BREAK_AFTER_LINE_NO') && \$ctrl.print.type === 'COORDINATE'">
    <td>Insert page sheet break after line no</td>
    <td>
      <input class="print-details__control-input"
             type="number"
             string-to-int
             ng-model="\$ctrl.getAttr('PAGE_SHEET_BREAK_AFTER_LINE_NO').value"
             ng-change="\$ctrl.onChange()"
             ng-step="1"
             min="1"
             ng-required="\$ctrl.getAttrBoolValue('PAGE_SHEET_BREAK_ENABLE')"/>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-general-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;